import axios from 'axios';

const axiosInstance = axios.create({
  //baseURL: '',
  timeout: 10000, // Request timeout
});

axiosInstance.interceptors.request.use(
  (config) => {
    // Add authorization token to headers if available
    const cmsLimitedAccessToken = localStorage.getItem(
      'ownership-claim-access-token',
    );
    if (cmsLimitedAccessToken) {
      config.headers['Cms-Limited-Access-Token'] = cmsLimitedAccessToken;
    }

    const cmsContext = window.localStorage.getItem('cmsContext');
    if (cmsContext) {
      config.headers['cms-context'] = cmsContext;
    }

    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    _lookForTheSessionObject(response);
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    if (error.response && error.response.status === 401) {
      // Handle unauthorized error, e.g., redirect to login
      console.error('Unauthorized, redirecting to login...');
    }
    return Promise.reject(error);
  },
);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _lookForTheSessionObject = (response: any) => {
  const authenticationUrls = [
    '/api/accessibe/signup',
    '/api/accessibe/social-signup-complete',
    '/api/accessibe/login',
    '/api/accessibe/google-login',
    '/api/accessibe/cms-provision',
  ];

  const logoutUrl = '/api/accessibe/logout';

  if (authenticationUrls.includes(response.config.url ?? '')) {
    if (response.data?.sessionObjects?.dashboardSession) {
      _createCookiesWithDashboard(
        response.data.sessionObjects.dashboardSession,
      );
    }
  } else if (logoutUrl === (response.config.url ?? '')) {
    _removeCookiesFromDashboard();
  }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const _createCookiesWithDashboard = async (dashboardSession: any) => {
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 30);

  const iframe = document.getElementById(
    'dashboard-session',
  ) as HTMLIFrameElement;
  if (iframe && iframe.contentWindow) {
    iframe.contentWindow?.postMessage(
      {
        eventName: 'DASHBOARD_SESSION',
        payload: {
          dashboardSession,
          expires: expiryDate,
        },
      },
      '*',
    );
  }
};

const _removeCookiesFromDashboard = async () => {
  const iframe = document.getElementById(
    'dashboard-session',
  ) as HTMLIFrameElement;

  if (iframe && iframe.contentWindow) {
    iframe.contentWindow.postMessage(
      {
        eventName: 'DASHBOARD_SESSION',
        payload: {
          dashboardSession: '',
          expires: new Date(0),
        },
      },
      '*',
    );
  }
};

export default axiosInstance;
